import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TieredMenuModule } from 'primeng/tieredmenu';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';


import { PlaceholderComponent } from '../standalone-components/placeholder/placeholder.component';
import * as SharedComponents from './components';
import * as SharedDirectives from './directives';
import * as SharedPipes from './pipes';

@NgModule({
    declarations: [
        ...SharedComponents.components,
        ...SharedDirectives.directives,
        ...SharedPipes.pipes,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        DialogModule,
        SelectModule,
        TieredMenuModule,
        PlaceholderComponent,
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        SelectModule,
        TieredMenuModule,
        FontAwesomeModule,
        PlaceholderComponent,
        ...SharedComponents.components,
        ...SharedDirectives.directives,
        ...SharedPipes.pipes,
    ],
})
export class SharedModule {}
